import frontImg from "../assets/front.png";
import backImg from "../assets/back.png";

export default function SampleIdDisplay() {
  const imgStyle = { width: "48%", borderRadius: 6, border: "1px solid #ddd" };
  return (
    <div style={{ background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: 8, padding: 16, marginBottom: 20 }}>
      <h3 style={{ color: "#333", marginTop: 0, marginBottom: 8 }}>Sample Test ID — Australian Driver's Licence (Victoria)</h3>
      <p style={{ fontSize: 12, color: "#444", lineHeight: 1.6, marginBottom: 12 }}>
        Use these sample images as your starting point for IDV testing. Screenshot the <strong>front</strong> image and
        edit it to place <strong>your own photo</strong> over the green square area — this is required so the selfie
        comparison can match the face on the ID.
      </p>
      <div style={{ display: "flex", gap: 16, justifyContent: "center" }}>
        <div style={{ textAlign: "center" }}>
          <img src={frontImg} alt="Sample VIC licence front" style={imgStyle} />
          <div style={{ fontSize: 11, color: "#666", marginTop: 4 }}>Front — edit the green square with your photo</div>
        </div>
        <div style={{ textAlign: "center" }}>
          <img src={backImg} alt="Sample VIC licence back" style={imgStyle} />
          <div style={{ fontSize: 11, color: "#666", marginTop: 4 }}>Back</div>
        </div>
      </div>
    </div>
  );
}
